export default __webpack_public_path__ + "397511801861ef4e36c13f93841e918f.svg";